import React from "react";
import ItineraryHubPage from "@/components/ItineraryHubPage";
import { HUB_MARRAKECH_LOOP } from "@/lib/itineraryHubs";
export default function MarrakechErgChebbiMarrakechHubPage() {
  return <ItineraryHubPage hub={HUB_MARRAKECH_LOOP} />;
}
